import { Box, Stack, type SxProps, type Theme } from "@mui/material";
import React from "react";

import { mergeSxProps } from "../../lib/mergeSxProps";
import { Divider } from "../Divider";

export interface KeyValueListProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export function KeyValueList(props: KeyValueListProps) {
  const { children, sx } = props;

  return (
    <Stack
      direction="column"
      sx={mergeSxProps(
        (theme) => ({
          border: `1px solid ${theme.palette.border?.subtle}`,
          borderRadius: theme.borderRadius?.medium,
          overflow: "hidden",
          px: 5,
          py: 2,
        }),
        sx
      )}
    >
      {React.Children.map(children, (child, index) => {
        const isLast = index === React.Children.count(children) - 1;
        return (
          <Box key={index}>
            {child}
            {!isLast && <Divider />}
          </Box>
        );
      })}
    </Stack>
  );
}
